import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { godTranslations, avoidWorks, compareCases, letteringJabs, faqs } from "@/mocks/site";

const heroStats = [
  { num: "1200+", label: "作品评测" },
  { num: "360+", label: "神翻译收录" },
  { num: "48", label: "栏目标签" },
  { num: "9.2", label: "平均评分" },
];

const feedbacks = [
  {
    name: "夜猫子K",
    role: "避雷区常驻读者",
    text: "靠着避雷区躲过好几个坑，以前读一半才发现是机翻，现在先查炮渣再开读，省心太多了。",
  },
  {
    name: "吃瓜路人甲",
    role: "神翻译爱好者",
    text: "神翻译合集的质量是真的稳，每一部我都挨个追完了，嵌字舒服到像在翻原作。",
  },
  {
    name: "撸串到天亮",
    role: "对比区贡献者",
    text: "翻译对比那个删页差异截图太顶了，以前真不知道自己少看了那么多关键分镜。",
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      {/* 首屏 Hero */}
      <section className="relative flex min-h-[560px] w-full flex-col items-center justify-center overflow-hidden bg-primary-500 pt-20 md:pt-0">
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.5) 0, transparent 40%), radial-gradient(circle at 80% 70%, rgba(0,0,0,0.4) 0, transparent 45%)",
          }}
        ></div>
        <div className="relative z-10 mx-auto w-full max-w-5xl px-4 text-center md:px-6">
          <span className="inline-flex items-center gap-2 rounded-full bg-black/20 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur-sm">
            <i className="ri-fire-line" aria-hidden="true"></i>
            神翻译合集 · 烂翻译避雷 · 翻译对比
          </span>
          <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
            翻译对比看清删页差异
            <br className="hidden md:block" />
            <span className="font-label text-background-50/95">只看舒服版本</span>
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-50/90 md:text-base">
            炮渣漫画网专注汉化质量评测：逐话对比神翻译与润色版，把机翻、删页、嵌字粗糙的作品一一避雷。
            帮你避开烂翻译烂嵌字，把时间花在真正舒服的版本上。
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/collections"
              className="inline-flex items-center gap-2 rounded-full bg-background-50 px-7 py-3 text-sm font-semibold whitespace-nowrap text-primary-600 transition-transform hover:-translate-y-0.5"
            >
              去看神翻译合集
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
            <Link
              to="/avoid"
              className="inline-flex items-center gap-2 rounded-full border border-background-50/40 px-7 py-3 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-shield-flash-line" aria-hidden="true"></i>
              先逛避雷区
            </Link>
          </div>

          <div className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-4 md:gap-4">
            {heroStats.map((s) => (
              <div key={s.label} className="rounded-xl bg-black/15 px-4 py-4 text-center backdrop-blur-sm">
                <p className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{s.num}</p>
                <p className="mt-1 text-xs text-background-50/80">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 神翻译精选 */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="font-label text-sm text-primary-600">GOD TRANSLATIONS</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">神翻译精选</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              逐话对比多个版本，从翻译准确度、润色自然度、嵌字排版、删页处理四个维度精选出的润色佳作。
            </p>
          </div>
          <Link
            to="/collections"
            className="hidden shrink-0 items-center gap-1 rounded-full bg-secondary-100 px-5 py-2.5 text-sm font-medium whitespace-nowrap text-secondary-900 transition-colors hover:bg-secondary-200 sm:inline-flex"
          >
            查看全部
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {godTranslations.map((m) => (
            <article
              key={m.id}
              className="group overflow-hidden rounded-xl bg-background-50 ring-1 ring-background-200 transition-shadow hover:shadow-lift"
            >
              <div className="relative h-56 w-full overflow-hidden">
                <img
                  src={m.image}
                  alt={`${m.title} 神翻译收录封面`}
                  title={`${m.title} 神翻译评测`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                  评分 {m.rating}
                </span>
                <span className="absolute right-3 top-3 rounded-full bg-black/40 px-3 py-1 text-xs text-background-50 backdrop-blur-sm">
                  {m.category}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950">{m.title}</h3>
                <p className="mt-0.5 text-xs text-foreground-500">{m.jpTitle}</p>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">{m.desc}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {m.tags.map((t) => (
                    <span key={t} className="rounded-full bg-background-100 px-2.5 py-0.5 text-xs text-foreground-600">
                      #{t}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* 避雷速报 */}
      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <div className="flex items-end justify-between gap-4">
            <div>
              <p className="font-label text-sm text-primary-600">AVOID LIST</p>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">避雷速报</h2>
              <p className="mt-2 max-w-xl text-sm text-foreground-600">
                机翻、删页、嵌字粗糙？这些版本建议直接避开，别把时间浪费在体验上。
              </p>
            </div>
            <Link
              to="/avoid"
              className="hidden shrink-0 items-center gap-1 rounded-full bg-secondary-100 px-5 py-2.5 text-sm font-medium whitespace-nowrap text-secondary-900 transition-colors hover:bg-secondary-200 sm:inline-flex"
            >
              进入避雷区
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>

          <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
            {avoidWorks.slice(0, 4).map((w) => (
              <article
                key={w.id}
                className="flex gap-4 rounded-xl bg-background-50 p-4 ring-1 ring-background-200 transition-shadow hover:shadow-lift"
              >
                <div className="h-28 w-20 shrink-0 overflow-hidden rounded-lg">
                  <img
                    src={w.image}
                    alt={`${w.title} 避雷封面`}
                    title={`${w.title} ${w.grade}`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="font-heading text-base font-bold text-foreground-950">{w.title}</h3>
                    <span
                      className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${
                        w.grade === "重度避雷"
                          ? "bg-primary-100 text-primary-700"
                          : "bg-accent-100 text-accent-800"
                      }`}
                    >
                      {w.grade}
                    </span>
                  </div>
                  <p className="mt-1 text-xs text-foreground-500">{w.version}</p>
                  <p className="mt-2 line-clamp-2 text-sm text-foreground-700">{w.redline}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* 翻译对比 */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="text-center">
          <p className="font-label text-sm text-primary-600">TRANSLATION COMPARISON</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">同作品 · 多版本对比</h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600">
            同一部作品不同版本的差异，一页页对比给你看，删页差异、译法优劣一目了然。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {compareCases.map((c) => (
            <article
              key={c.id}
              className="group overflow-hidden rounded-xl bg-background-50 ring-1 ring-background-200 transition-shadow hover:shadow-lift"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={c.image}
                  alt={`${c.title} 翻译对比图`}
                  title={`${c.title} 版本对比`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                  对比案例
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950">{c.title}</h3>
                <div className="mt-3 flex flex-wrap gap-2 text-xs">
                  {c.editions.map((e) => (
                    <span key={e} className="rounded-full bg-secondary-100 px-2.5 py-1 text-secondary-900">
                      {e}
                    </span>
                  ))}
                </div>
                <p className="mt-3 text-sm font-medium text-accent-700">结果：{c.result}</p>
                <ul className="mt-3 flex flex-col gap-1.5">
                  {c.points.map((p, i) => (
                    <li key={i} className="flex gap-2 text-sm text-foreground-700">
                      <i className="ri-checkbox-circle-line mt-0.5 text-accent-600" aria-hidden="true"></i>
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* 吐槽墙 */}
      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <div className="flex items-end justify-between gap-4">
            <div>
              <p className="font-label text-sm text-primary-600">EMBED LETTERING</p>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">嵌字 · 翻译吐槽墙</h2>
              <p className="mt-2 max-w-xl text-sm text-foreground-600">
                汉化行业里的常见乱象，一吐为快。这些坑你大概率也踩过。
              </p>
            </div>
            <Link
              to="/compare"
              className="hidden shrink-0 items-center gap-1 rounded-full bg-secondary-100 px-5 py-2.5 text-sm font-medium whitespace-nowrap text-secondary-900 transition-colors hover:bg-secondary-200 sm:inline-flex"
            >
              看对比案例
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>

          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2">
            {letteringJabs.map((j) => (
              <article key={j.id} className="rounded-xl bg-background-50 p-6 ring-1 ring-background-200">
                <div className="flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className="ri-chat-quote-line" aria-hidden="true"></i>
                  </span>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">{j.tag}</span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">{j.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{j.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="font-label text-sm text-primary-600">FAQ</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">常见问题</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于炮渣漫画网的收录标准、避雷评级与投稿方式，常见疑问都在这。还有想知道的，欢迎联系我们。
            </p>
            <Link
              to="/contact"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
            >
              联系炮渣
              <i className="ri-send-plane-line" aria-hidden="true"></i>
            </Link>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqs.map((f) => (
                <details
                  key={f.q}
                  className="group rounded-xl bg-background-50 ring-1 ring-background-200 open:shadow-lift"
                >
                  <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-5 py-4">
                    <h3 className="font-heading text-base font-semibold text-foreground-900">{f.q}</h3>
                    <i
                      className="ri-arrow-down-s-line shrink-0 text-xl text-foreground-500 transition-transform group-open:rotate-180"
                      aria-hidden="true"
                    ></i>
                  </summary>
                  <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-700">
                    {f.a}
                  </p>
                </details>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 口碑 */}
      <section className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <div className="text-center">
            <p className="font-label text-sm text-primary-600">COMMUNITY VOICE</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">读者怎么说</h2>
            <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600">
              来自追更、踩雷与避坑一线的真实反馈。
            </p>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
            {feedbacks.map((f) => (
              <figure key={f.name} className="rounded-xl bg-background-50 p-6 ring-1 ring-background-200">
                <div className="flex gap-0.5 text-accent-500">
                  <i className="ri-star-fill" aria-hidden="true"></i>
                  <i className="ri-star-fill" aria-hidden="true"></i>
                  <i className="ri-star-fill" aria-hidden="true"></i>
                  <i className="ri-star-fill" aria-hidden="true"></i>
                  <i className="ri-star-fill" aria-hidden="true"></i>
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{f.text}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 font-medium text-secondary-900">
                    {f.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{f.name}</p>
                    <p className="text-xs text-foreground-500">{f.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="relative overflow-hidden rounded-2xl bg-primary-500 px-6 py-12 text-center md:px-12 md:py-16">
          <div
            className="absolute inset-0 opacity-20"
            style={{
              backgroundImage:
                "radial-gradient(circle at 15% 85%, rgba(255,255,255,0.5) 0, transparent 40%), radial-gradient(circle at 85% 15%, rgba(0,0,0,0.4) 0, transparent 45%)",
            }}
          ></div>
          <div className="relative z-10">
            <h2 className="font-heading text-2xl font-black text-background-50 md:text-4xl">
              踩雷无数，不如直接看炮渣精选
            </h2>
            <p className="mx-auto mt-3 max-w-xl text-sm text-background-50/90 md:text-base">
              想看舒服版本，先把神翻译合集加入收藏；想少踩坑，就把避雷区存进书签。
            </p>
            <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                to="/collections"
                className="inline-flex items-center gap-2 rounded-full bg-background-50 px-7 py-3 text-sm font-semibold whitespace-nowrap text-primary-600"
              >
                查看神翻译合集
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
              <Link
                to="/avoid"
                className="inline-flex items-center gap-2 rounded-full border border-background-50/40 px-7 py-3 text-sm font-medium whitespace-nowrap text-background-50"
              >
                进入避雷区
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}